<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        iconName="el-icon-plus"
        @click.native="handleAdd"
        v-permission="'lecturerType:save'"
      ></butn>
    </div>
    <Tables :data="lecturerTypeTree" />
    <!-- 新增、编辑 -->
    <Curd />
  </div>
</template>
<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import Tables from "./table.js";
import Curd from "./curd";
import { lecturerTypeDelete, lecturerTypeTree } from "@/api/lecturertype";

export default {
  name: 'lecturertype',
  components: { butn, Tables, Curd },
  data() {
    return {
      size: "small",
      lecturerTypeTree: []
    };
  },
  methods: {
    handleAdd() {
      Bus.$emit("addLecturer", 0);
    },
    initData() {
      lecturerTypeTree().then(res => {
        this.lecturerTypeTree = res.data;
      });
    }
  },
  created() {
    this.initData();

    Bus.$on("lecturerTypeDelete", id => {
      this.$confirm("确认删除该讲师类别吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        lecturerTypeDelete({ uuids: [id] }).then(res => {
          if (res && res.code == 0) {
            this.initData();
          }
        });
      });
    });
    Bus.$on("reload", () => {
      this.initData();
    });
  }
};
</script>
